<bl-page-card-container
  id="rejeitados-receita-federal"
  backNavigation=".."
  [showTooltip]="true"
  [tooltipKey]="pageTooltip"
  (onCopyUrlFilters)="onCopyUrlFilters()"
  >
  <ng-container header>
    <div class="flex align-items-center">
      <ag-views-toolbar [grid]="agGrid" [gridKey]="GRID_KEY" class="mr-2"></ag-views-toolbar>
      <bl-competencia
        class="mr-2"
        [competencia]="competenciaRange[0]"
        [competenciaFinal]="competenciaRange[1]"
        (apply)="competenciaChanged($event)"
      ></bl-competencia>
      <button
        pButton
        type="button"
        icon="pi pi-search"
        iconPos="left"
        label="Pesquisar"
        class="mr-4 p-button p-button-md"
        [ngClass]="{ 'p-disabled': !filterChanged }"
        (click)="reloadData()"
      ></button>

      @if (pseudonimizarActionVisible) {
        <button
          class="p-button p-button-outlined p-button-icon-only"
          (click)="togglePseudonimizar()"
          [title]="(pseudonimizarAction ? 'Desativar' : 'Ativar') + ' Pseudonimização'"
          >
          <i class="pi" [ngClass]="pseudonimizarAction ? 'pi-eye-slash' : 'pi-eye'"></i>
        </button>
      }
      <button
        class="p-button p-button-outlined p-button-icon-only ml-2"
        (click)="exportExcel()"
        pTooltip="Exportar Listagem como XLSX"
        tooltipPosition="bottom"
        [disabled]="!rowData?.length"
        >
        <i class="pi pi-file-excel"></i>
      </button>
      <button
        class="p-button p-button-outlined p-button-icon-only ml-2"
        (click)="toggleFullscreen()"
        pTooltip="Tela Cheia"
        tooltipPosition="bottom"
        >
        <i
          class="pi"
          [ngClass]="{ 'pi-window-maximize': !(fullscreen$ | async), 'pi-window-minimize': (fullscreen$ | async) }"
          >
        </i>
      </button>
    </div>
  </ng-container>

  <p-tabs [(value)]="tabIndex" (valueChange)="onTabChange()">
    <p-tablist>
      <p-tab [value]="0">Guias TISS</p-tab>
      <p-tab [value]="1">Fornecimento direto</p-tab>
    </p-tablist>
    <p-tabpanels>
    <p-tabpanel [value]="0">
      <ag-grid-angular
        #agGrid
        class="ag-theme-balham w-full"
        [style.height]="gridHeight$ | async"
        [rowData]="rowData"
        [gridOptions]="gridOptions"
        [overlayLoadingTemplate]="firstLoad ? 'Clique em Pesquisar para exibir os registros' : null"
        >
      </ag-grid-angular>
    </p-tabpanel>
    <p-tabpanel [value]="1">
      <ag-grid-angular
        #agGridFornecimento
        class="ag-theme-balham w-full"
        [style.height]="gridHeight$ | async"
        [rowData]="rowDataFornecimento"
        [gridOptions]="gridOptionsFornecimento"
        [overlayLoadingTemplate]="firstLoad ? 'Clique em Pesquisar para exibir os registros' : null"
        >
      </ag-grid-angular>
    </p-tabpanel>
    </p-tabpanels>
  </p-tabs>
</bl-page-card-container>

<!-- Dialog for Guias tab -->
<p-dialog
  [(visible)]="dialogDisplay"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [maximizable]="true"
  (onMaximize)="onDialogMaximize($event)"
  (onHide)="onDialogHide($event)"
  [style]="{ width: '90vw', height: '90vh' }"
  >
  <ng-template pTemplate="header">
    <div class="flex justify-content-between w-full">
      <h5>Listagem de lançamentos de cruzamento de dados com RFB</h5>
      <div class="flex align-items-center gap-2 mr-2">
        <button
          class="p-button p-button-outlined p-button-icon-only mr-2"
          (click)="exportExcelDialog()"
          pTooltip="Exportar Listagem como XLSX"
          tooltipPosition="bottom"
          [disabled]="!dialogData?.length"
          >
          <i class="pi pi-file-excel"></i>
        </button>
        <button
          pButton
          pRipple
          type="button"
          icon="pi pi-angle-left"
          class="p-button-secondary p-button-text p-button-rounded p-button-icon-only"
          (click)="showDialogForPrev()"
          [disabled]="!canPrev()"
        ></button>
        <button
          pButton
          pRipple
          type="button"
          icon="pi pi-angle-right"
          class="p-button-secondary p-button-text p-button-rounded p-button-icon-only"
          (click)="showDialogForNext()"
          [disabled]="!canNext()"
        ></button>
      </div>
    </div>
  </ng-template>

  <div class="flex justify-content-end mb-2">
    <div class="flex align-items-center">
      <ag-views-toolbar [grid]="agGridDialog" [gridKey]="GRID_DIALOG_KEY"> </ag-views-toolbar>
    </div>
  </div>

  <div>
    <ag-grid-angular
      #agGridDialog
      class="ag-theme-balham"
      style="width: 100%"
      [style.height]="'calc(90vh - ' + dialogHeightPadding + 'px)'"
      [rowData]="dialogData"
      [gridOptions]="gridDialogOptions"
      >
    </ag-grid-angular>
  </div>
</p-dialog>

<!-- Dialog for Fornecimento tab -->
<p-dialog
  [(visible)]="dialogDisplayFornecimento"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [maximizable]="true"
  (onMaximize)="onDialogMaximize($event)"
  (onHide)="onDialogHide($event)"
  [style]="{ width: '90vw', height: '90vh' }"
  >
  <ng-template pTemplate="header">
    <div class="flex justify-content-between w-full">
      <h5>Listagem de lançamentos de cruzamento de dados com RFB - Fornecimento direto</h5>
      <div class="flex align-items-center gap-2 mr-2">
        <button
          class="p-button p-button-outlined p-button-icon-only mr-2"
          (click)="exportExcelDialog()"
          pTooltip="Exportar Listagem como XLSX"
          tooltipPosition="bottom"
          [disabled]="!dialogDataFornecimento?.length"
          >
          <i class="pi pi-file-excel"></i>
        </button>
        <button
          pButton
          pRipple
          type="button"
          icon="pi pi-angle-left"
          class="p-button-secondary p-button-text p-button-rounded p-button-icon-only"
          (click)="showDialogForPrev()"
          [disabled]="!canPrev()"
        ></button>
        <button
          pButton
          pRipple
          type="button"
          icon="pi pi-angle-right"
          class="p-button-secondary p-button-text p-button-rounded p-button-icon-only"
          (click)="showDialogForNext()"
          [disabled]="!canNext()"
        ></button>
      </div>
    </div>
  </ng-template>

  <div class="flex justify-content-end mb-2">
    <div class="flex align-items-center">
      <ag-views-toolbar [grid]="agGridDialogFornecimento" [gridKey]="GRID_DIALOG_KEY"> </ag-views-toolbar>
    </div>
  </div>

  <div>
    <ag-grid-angular
      #agGridDialogFornecimento
      class="ag-theme-balham"
      style="width: 100%"
      [style.height]="'calc(90vh - ' + dialogHeightPadding + 'px)'"
      [rowData]="dialogDataFornecimento"
      [gridOptions]="gridDialogFornecimentoOptions"
      >
    </ag-grid-angular>
  </div>

  <p-dialog
    [(visible)]="dialogDisplayFornecimentoDireto"
    [modal]="true"
    [draggable]="false"
    [resizable]="false"
    [maximizable]="true"
    [style]="{ width: '90vw', height: '90vh' }"
    header="Detalhe do lançamento de fornecimento direto"
    >
    <bl-fornecimento-direto-detalhe
      [operadora]="operadora"
      [cdGuiaMonitor]="detalheGuiaCodigoFornecimento"
      (onChange)="openDialogForFornecimentoDireto($event)"
    ></bl-fornecimento-direto-detalhe>
  </p-dialog>
</p-dialog>

<p-dialog
  [(visible)]="detalheGuiaDisplay"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [maximizable]="true"
  [style]="{ width: '90vw', height: '90vh' }"
  header="Detalhes da guia/lançamento"
  >
  <bl-detalhes-guia
    [operadora]="operadora"
    [cdGuiaMonitor]="detalheGuiaCodigo"
    (onChange)="showDetalheGuiaFor($event)"
  ></bl-detalhes-guia>
</p-dialog>
